import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);   // null = checking, false = logged out, obj = user
  const [tenant, setTenant] = useState(null);

  const applyBranding = useCallback((t) => {
    setTenant(t || null);
    const root = document.documentElement;
    if (t?.primary_color) root.style.setProperty("--brand", hexToRgb(t.primary_color));
    if (t?.accent_color) root.style.setProperty("--brand-accent", hexToRgb(t.accent_color));
  }, []);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem("aru_session")) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      applyBranding(data.tenant);
    } catch {
      localStorage.removeItem("aru_session");
      setUser(false);
    }
  }, [applyBranding]);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("aru_session", "1");
    setUser(data);
    applyBranding(data.tenant);
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout");
    localStorage.removeItem("aru_session");
    setUser(false);
    setTenant(null);
  };

  return (
    <AuthContext.Provider value={{ user, tenant, login, logout, refresh, setTenantBranding: applyBranding }}>
      {children}
    </AuthContext.Provider>
  );
}

function hexToRgb(hex) {
  const h = hex.replace("#", "");
  const n = parseInt(h.length === 3 ? h.split("").map((c) => c + c).join("") : h, 16);
  return `${(n >> 16) & 255} ${(n >> 8) & 255} ${n & 255}`;
}

export const useAuth = () => useContext(AuthContext);
